module.exports = __webpack_public_path__ + "static/media/iron-ore-1.db60d55d.glb";